import type {
  InvoiceReminderResponseDto,
  InvoiceRemindersControllerListInvoiceRemindersParams,
  ReminderEmailPreviewResponseDto,
  StopInvoiceRemindersResponseDto,
} from '@trellis/api'
import type { ReminderEmailStage, UpdateInvoiceReminder } from '@trellis/shared'

import { apiClient } from '@/lib/api-client'
import { request } from '@/lib/request'

export type InvoiceRemindersListParams =
  InvoiceRemindersControllerListInvoiceRemindersParams

export const listInvoiceReminders = (params: InvoiceRemindersListParams = {}) =>
  request<InvoiceReminderResponseDto[]>(() =>
    apiClient.api.invoiceRemindersControllerListInvoiceReminders(params),
  )

/** Dismisses a scheduled reminder (`DISMISSED`) or restores a dismissed one (`SCHEDULED`). */
export const updateInvoiceReminder = (id: string, data: UpdateInvoiceReminder) =>
  request<InvoiceReminderResponseDto>(() =>
    apiClient.api.invoiceRemindersControllerUpdateInvoiceReminder({ id }, data),
  )

export const stopInvoiceReminders = (invoiceId: string) =>
  request<StopInvoiceRemindersResponseDto>(() =>
    apiClient.api.invoiceRemindersControllerStopInvoiceReminders({ id: invoiceId }),
  )

export const getReminderEmailPreview = (stage: ReminderEmailStage) =>
  request<ReminderEmailPreviewResponseDto>(() =>
    apiClient.api.reminderSchedulesControllerPreviewReminderEmail({ stage }),
  )
